import Typography from 'typography';

//import lawtonTheme from "typography-theme-moraga"
//import zackliveTheme from "typography-theme-zacklive"
//const typography = new Typography(zackliveTheme)

const typography = new Typography({
  baseFontSize: '16px',
  baseLineHeight: 1.5,
  scaleRatio: 2.5,
  googleFonts: [
    {
      name: 'Raleway',
      styles: ['300','300i','500', '700', '700i'],
    },
    {
      name: 'Roboto',
      styles: ['400', '400i', '700', '700i'],
    },
  ],
  includeNormalize: true,
  headerFontFamily: [
    'Raleway',
    'Avenir Next',
    'Helvetica Neue',
    'Segoe UI',
    'Helvetica',
    'Arial',
    'sans-serif'
  ],
  bodyFontFamily: [
    'Roboto',
    'Avenir Next',
    'Helvetica Neue',
    'Segoe UI',
    'Helvetica',
    'Arial',
    'sans-serif'
  ],
  headerWeight: 300,
  bodyWeight: 400,
  overrideStyles: ({ adjustFontSizeTo, scale, rhythm }, options) => {
    return {
      a: {
        color: 'black'
      }
    };
  }
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js